import { TYPES } from '../constants';
import { getCategoryPath } from './items/category';
import { getSubCategoryPath } from './items/sub_category';
import { getStorePath } from './items/store';
import { getSearchQueryPath } from './items/search_query';
import { getStaticPagePath } from './items/filtered_page';
import { getNestedSubCategoryPath } from './items/nested_sub_category';

export const mapper = {
    [TYPES.CATEGORY]: getCategoryPath,
    [TYPES.SUB_CATEGORY]: getSubCategoryPath,
    [TYPES.CMS]: getStorePath,
    [TYPES.SEARCH_QUERY]: getSearchQueryPath,
    [TYPES.FILTERED_PAGE]: getStaticPagePath,
    [TYPES.NESTED_SUB_CATEGORY]: getNestedSubCategoryPath
};